import React, { useState, useEffect, useRef } from "react";
import classes from './SingleBlogPage.module.css';
import Header from "../../../Global/Header/Header";
import Footer from "../../../Global/Footer/Footer";
import { get, createUrl } from "../../../network/AxiosInterceptor";

const SingleBlogPage = () => {
    const [height, setHeight] = useState("100vh");
    const blogRef = useRef(null);
    const [blogId, setBlogId] = useState("");

    useEffect(() => {
        get(createUrl(`/api/blogs/${window.location.pathname.split("/")[2]}`)).then((response) => {
            setBlogId(response.data.blogUrl)
        })
    }, [])


    return (
        <div className={`flex flex-col`}>

            {blogId != "" && <><div className="absolute w-full z-[100] bg-white p-0 m-0 overflow-hidden">
                <Header />
            </div>
                <div className={` min-h-[120vh] lg:min-h-[200vh] mt-[-50px] lg:mt-[-45px]`}>
                    <iframe ref={blogRef} className={`relative w-full min-h-[120vh] lg:min-h-[200vh]`} id="blog-frame" src={blogId} />
                    <div className="relative z-[1] mt-[-100px] lg:mt-[-60px]">
                        <Footer />
                    </div>
                </div>
            </>
            }

        </div>
    )
};

export default SingleBlogPage;